<h1>
    <img [ngSrc]="logoSrc"
         [alt]="logoAlt"
         width="400"
         height="200">
</h1>
